module.exports = __webpack_public_path__ + "static/media/shapes_21.ea352419.svg";